import React, { useState } from "react";
import { Menu, Icon, Button } from "semantic-ui-react";
import { PropTypes } from "prop-types";
import DocumentationMenuItems from "./documentation-menu-items";

const DocumentationMobileMenu = ({ selectedItem, handleItemClick }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      <Button
        icon
        basic
        onClick={toggleMenu}
        style={{ marginBottom: "1em", width: "100%" }}
      >
        <Icon name={isMenuOpen ? "angle up" : "angle down"} />
        Menu
      </Button>
      {isMenuOpen && (
        <Menu vertical tabular fluid style={{ paddingLeft: "1em" }}>
          <DocumentationMenuItems
            selectedItem={selectedItem}
            handleItemClick={handleItemClick}
            isMobile={true}
          />
        </Menu>
      )}
    </div>
  );
};

DocumentationMobileMenu.propTypes = {
  selectedItem: PropTypes.string.isRequired,
  handleItemClick: PropTypes.func.isRequired,
};

export default DocumentationMobileMenu;
